import { InventoryProps } from "./InventoryPage";
import Chip from "../../Components/Chip";

const InventoryStatus = ({ inventory } : InventoryProps) => (
	<Chip
		label={!inventory.inventoryDate ? "In Bearbeitung" : "Abgeschlossen"}
		color={!inventory.inventoryDate ? "secondary" : "primary"}
	/>
);

export default InventoryStatus;
